if (!customElements.get('timeline-accordion')) {
  class TimelineAccordion extends window.BaseComponent {
    constructor() {
      super();
    }

    init() {
      this.items = this.querySelectorAll('.timeline-item');
      this.headings = this.querySelectorAll('.timeline-heading');
      this.dots = this.querySelectorAll('.timeline-dot-wrapper');
      this.isMobile = window.innerWidth < 750;

      this.headings.forEach((heading, index) => {
        heading.addEventListener('click', () => this.toggleItem(index));
      });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.toggleItem(index));
      });

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
      });

      this.initHeightSync();
    }

    initHeightSync() {
      // Find the media container matching this section
      const sectionId = this.dataset.section;
      const mediaContainer = document.querySelector(`.product__media-list[data-section="${sectionId}"]`);

      if (!mediaContainer) return;

      // Update CSS variable with the height of the media container
      const updateHeight = () => {
        if (!this.isMobile) {
          const targetTotalHeight = mediaContainer.offsetHeight;
          this.style.setProperty('--timeline-min-height', `${targetTotalHeight}px`);

          // Force EXACT inner content height to push the tabs apart perfectly
          let fixedElementsHeight = 0;
          this.querySelectorAll('.timeline-heading').forEach(h => {
            fixedElementsHeight += h.offsetHeight;
          });

          // Padding/Gap approximations (roughly 45px padding + 26px dot offset per item)
          const visualSpacing = this.items.length * 30; // buffer amount

          const availableContentHeight = targetTotalHeight - fixedElementsHeight - visualSpacing;

          this.style.setProperty('--available-content-height', `${Math.max(100, availableContentHeight)}px`);

        } else {
          this.style.removeProperty('--timeline-min-height');
          this.style.removeProperty('--available-content-height');
        }
      };

      // Initial set
      updateHeight();

      // Watch for resizes
      const resizeObserver = new ResizeObserver(() => updateHeight());
      resizeObserver.observe(mediaContainer);
    }

    toggleItem(index) {
      if (this.items[index].classList.contains('is-active')) return;

      const currentItem = this.querySelector('.timeline-item.is-active');
      const targetItem = this.items[index];

      // Mobile: Instant switch to maintain "past" functionality without scrolling jitter
      if (this.isMobile) {
        if (currentItem) currentItem.classList.remove('is-active');
        targetItem.classList.add('is-active');
        // Removed scrollToTab(targetItem) here because inline: 'center' causes horizontal shifting
        return;
      }

      // Desktop: Smooth Simultaneous GSAP Transition
      if (typeof gsap !== 'undefined') {
        const currentContent = currentItem?.querySelector('.timeline-content');
        const targetContent = targetItem.querySelector('.timeline-content');

        const tl = gsap.timeline({
          onStart: () => {
            targetItem.classList.add('is-active');
            if (currentItem) currentItem.classList.remove('is-active');
          }
        });

        // Close current (if exists)
        if (currentContent) {
          gsap.set(currentContent, { height: currentContent.offsetHeight }); // Lock height for animation
          tl.to(currentContent, {
            height: 0,
            opacity: 0,
            duration: 0.4,
            ease: 'power2.inOut',
            clearProps: 'height,opacity'
          }, 0);
        }

        // Open target
        tl.fromTo(targetContent,
          { height: 0, opacity: 0 },
          {
            height: 'auto',
            opacity: 1,
            duration: 0.4,
            ease: 'power2.inOut',
            clearProps: 'height'
          }, 0);
      } else {
        // Fallback if GSAP is missing
        if (currentItem) currentItem.classList.remove('is-active');
        targetItem.classList.add('is-active');
      }
    }

    scrollToTab(item) {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

  }

  if (window.BaseComponent) {
    customElements.define('timeline-accordion', TimelineAccordion);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.BaseComponent) customElements.define('timeline-accordion', TimelineAccordion);
    });
  }
}
